module.exports = "<p>\r\n  cover works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Source/Ecim/Ecim.Web/src/app/components/cover/cover.component.html
// module id = ../../../../../src/app/components/cover/cover.component.html
// module chunks = main